import axios from '../utils/axios';

export default function get(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/search/query-report', { params })
    )
}